export default "__VITE_ASSET__Dv2GWCgK__"